export type { TableProps, TableRow } from './table';
export { default } from './table';
